const WEB_URL =
  "https://qa.euopsysweb.com/sso?refID=ESSSPAINES&loginName=610551&loginEncryptedPassword=DqKTCwJs1IZAkckNgGnpQeLZycoco%2FPsBDs0ZgI4qu16A9xw4DC5oNWhSzt5nmzweZtBWTHgdyNFtqiAQddmg%2B6%2Fbkcd%2BwutUsIeiahYWd2TZ6Wj1H35imsm1VzEm%2FjM9%2BETGBqr3EzWFB5VzCmSSqnhV69c%2FxQpVh5I3w77WJRtlNKclLQmJL8Ydog%2Fcj6gf9PF1N%2BMOlLuPICeXtlauFKOlLwTwAcVETJGpGS%2FHWJPb7Vpq7yJK6fhOrPoYCyjE%2FLHiaBSyX1DM5nypfHU6v7C%2FIzd%2FG%2BtRDYRK829A1GWaGXxHgvxvPTOVOG26gIIGvJ2%2Fik2Z%2BhFW%2BwGpUKOUw%3D%3D&locale=es-ES&ExternalId=999658&PmsId=VWOPTIWIN";

//const WEB_URL = "https://www.himalayac.com";

export default function OnlineOrders(props) {
  if (!props.show) {
    return <></>;
  }

  return (
    <>
      <div className="patient-data">
        <iframe className="debug-iframe" src={WEB_URL} />
      </div>
    </>
  );
}
